import ToolCard from '../../../components/feature/ToolCard';
import { featuredTools } from '../../../mocks/tools';

export default function FeaturedTools() {
  // Deduplicate by slug in case of any import overlaps
  const uniqueTools = featuredTools.filter(
    (tool, index, self) => self.findIndex((t) => t.slug === tool.slug) === index
  );

  return (
    <section className="px-6 bg-[#0a0a0a]" style={{ marginTop: 0, paddingTop: '40px', paddingBottom: '80px' }}>
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-teal-500/10 border border-teal-500/20 text-teal-400 text-xs font-semibold tracking-widest uppercase mb-5">
            Handpicked
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-5 tracking-tight leading-tight">
            Featured AI Tools
          </h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto leading-relaxed">
            Discover the most popular and powerful AI tools trusted by creators and businesses worldwide.
          </p>
        </div>

        {/* Tools Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {uniqueTools.map((tool) => (
            <ToolCard key={tool.id} tool={tool} />
          ))}
        </div>
      </div>
    </section>
  );
}
